enum testIds {
	listOfActionLinks = 'client_action_list',
	clientLeadsLink = 'client_leads',
	documentLibraryLink = 'document_library',
	formAndBrochuresLink = 'forms_brochures',
}

export default testIds;
